export default __webpack_public_path__ + "static/Nerd-ba90591229a9d55a1243debc9b01d89b.png";